import { signal } from 'services/SignalsService'
const name = 'INTRO'

async function execute() {
  signal.dispatch('INIT:PAYTABLE:SLIDER')
  const winModel = game.models.WinModel.get()
  if(winModel.respinWin > 0){
    const amount = winModel.respinWin
    const type = 'regular'
    signal.dispatch('RECOVERY:RE-SPIN-LAST-WIN', { type, amount } )
  }

  const freespinModel = game.models.FreespinModel.get()
  signal.dispatch(freespinModel.all
    ? 'INIT:FREESPINS'
    : 'INIT:REGULAR')

  return signal.promise('BUTTON:close')

}

export function getIntroAction() {
  return {
    name,
    execute,
  }
}
